import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "./../../config/api";

export default function Login({ isOpen, onClose, openRegister }) {
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState("+91");

  const [formData, setFormData] = useState({
    identifier: "",
    password: "",
    country_code: "+91",
    new_password: "",
  });

  // Validation states
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [forgotIdentifier, setForgotIdentifier] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  // ================= IMPROVED VALIDATION =================
  const validateForm = () => {
    const newErrors = {};
    const value = formData.identifier.trim();

    if (!value) {
      newErrors.identifier = "Email or Phone number is required";
    } else {
      const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

      if (!isEmail) {
        const digits = value.replace(/\D/g, "");
        if (digits.length < 8 || digits.length > 15) {
          newErrors.identifier = "Enter valid phone number (8-15 digits)";
        }
      }
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ================= HANDLE CHANGE =================
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ================= FIXED LOGIN =================
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      let identifierToSend = formData.identifier.trim();
      const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identifierToSend);

      // ✅ FIXED: Send RAW identifier to backend
      // Backend will normalize phone numbers automatically
      const payload = {
        identifier: identifierToSend, // Send as-is (email or phone with/without country code)
        password: formData.password,
      };

      console.log("📤 Sending payload:", payload); // Debug log

      const res = await fetch(API.LOGIN, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!data.success) {
        alert(`⚠️ ${data.message || "Invalid credentials"}`);
        setFormData((prev) => ({
          ...prev,
          password: "",
        }));
        return;
      }

      // 🚫 Blocked user check
      if (data.user?.status?.toLowerCase() === "blocked") {
        sessionStorage.removeItem("user");
        alert("🚫 Your account has been blocked.");
        return;
      }

      // ✅ Store user data
      const userData = {
        ...data.user,
        provider_options: Array.isArray(data.user.provider_options)
          ? data.user.provider_options
          : data.user.provider_options
            ? JSON.parse(data.user.provider_options || "[]")
            : [],
      };

      sessionStorage.setItem("user", JSON.stringify(userData));
      sessionStorage.setItem("userId", data.user.id);

      window.dispatchEvent(new Event("userLogin"));
      onClose();

      // Navigate based on role
      if (data.user.role === "admin") {
        window.open("/admin/dashboard", "_blank");
      } else if (data.user.account_type === "provider") {
        window.open("/user/dashboard", "_blank");
      } else {
        window.open("/", "_blank");
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Server error");
    } finally {
      setIsSubmitting(false);
    }
  };

  // ================= FORGOT PASSWORD =================
  // Replace ONLY your current handleForgotPassword function with this
  // Replace your current handleForgotPassword function with this

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    if (!forgotIdentifier.trim()) {
      alert("Enter mobile number");
      return;
    }

    if (!(formData.new_password || "").trim()) {
      alert("Enter new password");
      return;
    }

    let mobile = forgotIdentifier.replace(/\D/g, ""); // ✅ FIX

    if (mobile.length < 8 || mobile.length > 15) {
      alert("Enter valid mobile number");
      return;
    }

    setForgotLoading(true);

    try {
      const res = await fetch(API.UPDATE_PASSWORD, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mobile: mobile, // ✅ IMPORTANT FIX HERE
          new_password: formData.new_password,
        }),
      });

      const data = await res.json();

      if (data.success) {
        alert("Password updated successfully");

        setShowForgot(false);
        setForgotIdentifier("");

        setFormData((prev) => ({
          ...prev,
          new_password: "",
        }));
      } else {
        alert(data.message || "Failed to update password");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    } finally {
      setForgotLoading(false);
    }
  }; // ================= STATUS CHECK =================
  useEffect(() => {
    const checkUserStatus = async () => {
      const savedUser = JSON.parse(sessionStorage.getItem("user"));
      if (savedUser && savedUser.id) {
        try {
          const res = await fetch(`${API.GET_USER_STATUS}?id=${savedUser.id}`);
          const data = await res.json();

          if (data.status?.toLowerCase() === "blocked") {
            sessionStorage.removeItem("user");
            alert("Account blocked");
            navigate("/");
          }
        } catch (error) {
          console.log(error);
        }
      }
    };

    checkUserStatus();
    const interval = setInterval(checkUserStatus, 300000);
    return () => clearInterval(interval);
  }, [navigate]);

  if (!isOpen) return null;

  return (
    <>
      {/* LOGIN MODAL */}
      <div className="login-popup-overlay" onClick={onClose}>
        <div className="login-popup-card" onClick={(e) => e.stopPropagation()}>
          <button className="login-popup-close" onClick={onClose}>
            ✕
          </button>

          <h2 className="login-popup-title">Sign In</h2>

          <form onSubmit={handleSubmit}>
            {/* IDENTIFIER */}
            <div className="login-popup-form-group">
              <label>Mobile Number</label>

              <input
                type="text"
                name="identifier"
                className={`login-popup-input ${
                  errors.identifier ? "is-invalid" : ""
                }`}
                value={formData.identifier}
                onChange={handleChange}
                placeholder="Enter mobile number"
                autoComplete="username"
              />

              {errors.identifier && (
                <div className="login-popup-error">{errors.identifier}</div>
              )}
            </div>

            {/* PASSWORD */}
            <div className="login-popup-form-group">
              <label>Password</label>

              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className={`login-popup-input ${
                    errors.password ? "is-invalid" : ""
                  }`}
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter password"
                  autoComplete="current-password"
                />

                <span
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i
                    className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                  ></i>
                </span>
              </div>

              {errors.password && (
                <div className="login-popup-error">{errors.password}</div>
              )}
            </div>

            {/* SUBMIT BUTTON */}
            <button
              type="submit"
              className="login-popup-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Signing in..." : "Login"}
            </button>
          </form>

          {/* FOOTER */}
          <div className="login-popup-footer">
            <p>
              New here?{" "}
              <span
                className="login-popup-link"
                onClick={() => {
                  onClose();
                  openRegister();
                }}
              >
                Create Account
              </span>
            </p>

            <span
              className="login-popup-forgot"
              onClick={() => setShowForgot(true)}
            >
              Forgot Password?
            </span>
          </div>
        </div>
      </div>

      {/* FORGOT PASSWORD MODAL */}
      {showForgot && (
        <div className="login-popup-overlay">
          <div className="login-popup-card">
            <button
              className="login-popup-close"
              onClick={() => {
                setShowForgot(false);
                setForgotIdentifier("");

                setFormData((prev) => ({
                  ...prev,
                  new_password: "",
                }));
              }}
            >
              ✕
            </button>

            <h2 className="login-popup-title">Reset Password</h2>

            <form onSubmit={handleForgotPassword}>
              {/* MOBILE / EMAIL */}
              <div className="login-popup-form-group">
                <label> Mobile Number</label>

                <input
                  type="text"
                  className="login-popup-input"
                  placeholder="Enter mobile number"
                  value={forgotIdentifier}
                  onChange={(e) => setForgotIdentifier(e.target.value)}
                />
              </div>

              {/* NEW PASSWORD */}
              <div className="login-popup-form-group">
                <label>New Password</label>

                <div className="password-wrapper">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    className="login-popup-input"
                    placeholder="Enter new password"
                    value={formData.new_password || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        new_password: e.target.value,
                      })
                    }
                  />

                  <span
                    className="password-toggle"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    <i
                      className={`bi ${
                        showNewPassword ? "bi-eye-slash" : "bi-eye"
                      }`}
                    ></i>
                  </span>
                </div>
              </div>

              <button
                type="submit"
                className="login-popup-btn"
                disabled={forgotLoading}
              >
                {forgotLoading ? "Updating..." : "Update Password"}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
